import React from "react";

const SubHeader = (props) => {
  return (
    <div className="sub-header" {...props}>
      {props.title}
    </div>
  );
};

export default SubHeader;



// WEBPACK FOOTER //
// ./src/components/common/subHeader.js